export const CouriersColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'ФИО, ИИН',
        key: 'fullName',
    },
    {
        name: 'Код 1C',
        key: 'code1C',
    },
    {
        name: 'Телефон',
        key: 'phoneNumber',
    },
    {
        name: 'Поставщик',
        key: 'company',
        customHint: 'name',
    },
    {
        name: 'Сектор диспетчера',
        key: 'dispatcherSector',
    },
    {
        name: 'Гос. номер и марка авто',
        key: 'car',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]
